import { FirmContext } from "../contexts/AuthContext";
import { isSuperAdmin } from "./superRoles";

export const canViewOwnPreference = (firmContext: FirmContext | null | undefined): boolean => {
  if (!firmContext?.permissions) return false;
  return Boolean(firmContext.permissions.preferences?.view_own);
};

export const canEditOwnPreference = (firmContext: FirmContext | null | undefined): boolean => {
  if (!firmContext?.permissions) return false;
  if (isSuperAdmin(firmContext)) return true;
  return Boolean(firmContext.permissions.preferences?.edit_own);
};
